const ErrorService = {
    getMessage: (e: any) => {
        // Log detailed error to console for debugging
        console.error("Detailed Error:", e);

        if (e && e.response) {
            const status = e.response.status;
            let msg = e.response.data?.message || e.response.data?.error || "";
            if (typeof msg === 'object') {
                msg = JSON.stringify(msg);
            }
            const lowerMsg = msg.toLowerCase();

            // Custom friendly message mappings based on backend keys/messages
            if (lowerMsg.includes("no_access") || lowerMsg.includes("unauthorized") || status === 403) {
                return "You do not have permission to perform this action.";
            }
            if (lowerMsg.includes("not_found") || status === 404) {
                return "The requested resource was not found.";
            }
            if (lowerMsg.includes("not_valid") || status === 422) {
                return "The input data is invalid. Please check and try again.";
            }
            if (lowerMsg.includes("vendor") && (lowerMsg.includes("verify") || lowerMsg.includes("verified") || lowerMsg.includes("unverified") || lowerMsg.includes("belum verify") || lowerMsg.includes("belum diverifikasi") || lowerMsg.includes("belum verifikasi"))) {
                return "The vendor has not been verified yet.";
            }
            if (lowerMsg.includes("profit") && lowerMsg.includes("di bawah 5%")) {
                return "Approval failed: Offer profit is below 5% and you do not have permission to approve low profit offers.";
            }
            if (lowerMsg.includes("penawaran anda sendiri") || lowerMsg.includes("penawaran Anda sendiri")) {
                return "Approval failed: You do not have permission to approve your own offers.";
            }
            if (lowerMsg.includes("penawaran sales lain")) {
                return "Approval failed: You do not have permission to approve other sales' offers.";
            }
            if (lowerMsg.includes("bad_request") || status === 400) {
                return "Invalid request. Please try again.";
            }
            if (status === 401) {
                return "Session expired. Please log in again.";
            }
            return msg || "A server error occurred. Please try again later.";
        }

        if (e && e.request) {
            return "Connection failed. Please check your internet connection.";
        }

        return e.message || e.toString();
    }
};

export default ErrorService;